<script setup lang='ts'>
import { useIsSp } from '@mp/hooks'

// import { Popover } from 'ant-design-vue'

// import imgWechat from './images/wechat.png'

const { isNotSp, name, beian } = useIsSp()
</script>

<template>
  <div class="text-center text-sm text-n-90 mt-12 pb-8 leading-6! relative">
    <template v-if="isNotSp">
      <p>{{ name }}</p>
      <p><a href="https://beian.miit.gov.cn/" target="_blank" class="hover:text-primary">{{ beian }}</a></p>
    </template>
    <template v-else>
      <div>&copy; 2023 上海盛付通电子支付服务有限公司</div>
      <div>
        <a href="http://news.shengpay.com/aboutus" target="_blank" class="text-n-90 hover:text-primary">关于盛付通</a>
        |
        <a href="https://www.shengpay.com/" target="_blank" class="text-n-90 hover:text-primary">盛付通官网</a>
        |
        <a href="http://news.shengpay.com/aboutus/contacts" target="_blank" class="text-n-90 hover:text-primary">联系我们</a>
      </div>

      <div>
        <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502001963" target="_blank" class="text-n-90 hover:text-primary">沪公网备31011502001963号</a>
        |
        <a href="https://beian.miit.gov.cn/" target="_blank" class="text-n-90 hover:text-primary">沪ICP备08024653号-10</a>
      </div>

      <div>客服支持: 400-720-8888 &nbsp; 人工服务: 9:00-22:00  &nbsp; 自助服务: 7x24小时</div>
    </template>
  </div>
</template>
